import TableMovie from "../components/TableMovie"
import SideBar from "../components/SideBar"

export default function HomePage(){
    return(
        <div>
     <SideBar/>
     <TableMovie/>
        </div>
    )
}